module.exports = "<div class=\"main-wrapper\">\n  <div class=\"app\" id=\"app\">\n    <app-header></app-header>\n    <app-sidenav></app-sidenav>\n    <div class=\"sidebar-overlay\" id=\"sidebar-overlay\"></div>\n    <article class=\"content dashboard-page\">\n      <router-outlet></router-outlet>\n      \n    </article>\n    <app-footer>\n    </app-footer>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = 361
// module chunks = 1